import { render, staticRenderFns } from "./SidebarLayoutSidebar.vue?vue&type=template&id=57b70ed0&"
import script from "./SidebarLayoutSidebar.vue?vue&type=script&lang=js&"
export * from "./SidebarLayoutSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports